import React, { FC, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store/ducks';
//components
import { CustomAnimated, HideSliderButton } from './styles';
import { Visibility } from 'components/Visibility';
import { Row } from 'components/Layout/Grid';
//generics
import { useOutsideClick } from 'hooks/useOutsideClick';
//assets
import hideSliderIcon from 'img/hide-slider-icon.svg';

const CustomSlider: FC = () => {
  const customSlider = useSelector((state: RootState) => state.customSlider);
  
  const [shouldRender, setShouldRender] = useState(customSlider?.show);
  const dispatch = useDispatch();
  const wrapperRef = useRef(null);

  useOutsideClick(wrapperRef, () => dispatch({ type: 'CLOSE_CUSTOM_SLIDER' }));
  
  useEffect(() => {
    if (customSlider?.show) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'scroll';
    }
    setShouldRender(customSlider?.show)
  }, [customSlider]);

  return (
    <>
      {customSlider?.show && (
        <Row className="fixed top-0 bottom-0 right-0 left-0 bg-modal z-999" />
      )}
      <Visibility visible={!!shouldRender}>
        <CustomAnimated
          show={!!customSlider?.show}
          className={`bg-primary d-flex z-999 w-md-30-vw`}
        >
          <div ref={wrapperRef} className={`pr-3 pl-3 pb-4 pt-md-4 h-100 w-100 overflow-y-auto`}>
            <Row className="justify-end flex-1">
              <HideSliderButton onClick={() => { dispatch({ type: 'CLOSE_CUSTOM_SLIDER' }); dispatch({ type: 'SHOW_TITLE' }); }}>
                <img src={hideSliderIcon} alt="hide slider button" />
              </HideSliderButton>
            </Row>
            {customSlider?.content && <customSlider.content />}
          </div>
        </CustomAnimated>
      </Visibility>
    </>
  );
};

export default CustomSlider;
